import React from "react";

import classNames from "classnames";

import type { Item } from "@typings/product/item";

interface CartItemImgProps {
  item: Item;
  redirectToProductPage: () => void;
}

const CartItemImg = ({ item, redirectToProductPage }: CartItemImgProps) => {
  return (
    <button type="button" onClick={redirectToProductPage} className={classNames("cart-item__img")}>
      <img
        className="cart-item__img-content"
        src={item.information?.images.cartImg || item.mainImage}
        alt={item.name}
      />
    </button>
  );
};

export default CartItemImg;
